import { useMutation } from '@vue/apollo-composable'
import { graphql } from '@/gql'
import { PER_PAGE_MAXIMUM } from '@/utils/constants'

export const useUpdateTimesheet = (timesheetPayload) =>
  useMutation(
    graphql(/* GraphQL */ `
      mutation updateTimesheet($input: UpdateTimesheetInput!, $first: Int) {
        updateTimesheet(input: $input) {
          ...TimesheetFormFragment
        }
      }
    `),
    () => ({
      variables: {
        input: {
          id: timesheetPayload.value.id,
          startDate: timesheetPayload.value.startDate,
          endDate: timesheetPayload.value.endDate,
          registrations: timesheetPayload.value.registrations,
        },
        first: PER_PAGE_MAXIMUM,
      },
      clientId: 'publicApi',
    }),
  )
